import { render, staticRenderFns } from "./WidgetCategoryReviewsGalleryMobile.vue?vue&type=template&id=793db445"
import script from "./WidgetCategoryReviewsGalleryMobile.vue?vue&type=script&lang=js"
export * from "./WidgetCategoryReviewsGalleryMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports